<template>
  <div :class="config.useInternalEdit ? 'card' : ''" class="taggings">
    <div
      v-if="config.useInternalEdit"
      :class="config.useInternalEdit ? 'card-header' : ''"
    >
      <!-- this was a b-card header, but you removed b-card -- might need to work on styles -->
      <TagFieldsHeader
        :title="title"
        :isEditing="isEditingCurrent"
        :disabled="isLoading || !tagFieldsLoaded || !hasTagFields"
        @edit="onEdit"
        @cancel="onEditCancel"
        @save="onSave"
      />
    </div>
    <div 
      :class="config.useInternalEdit ? 'card-body' : ''"
      class="d-flex flex-wrap"
    >
      <div
        v-if="isLoading || !tagFieldsLoaded"
        class="w-100 d-flex justify-content-center gap-2"
      >
        <b-spinner></b-spinner>
      </div>
      <div
        v-else
        class="w-100"
      >
        <div v-if="!hasTagFields" key="noTagFields" class="text-uppercase text-muted text-center">No {{ title }} to show</div>
        <TagFieldList
          :value="value"
          @input="handleTagFieldListInput"
          :tagFields="tagFields"
          :isEditing="isEditingCurrent"
          :objectId="config.objectId"
          :layout="config.layout"
          class="w-100"
        />
      </div>
    </div>
    <!-- <div class="d-flex w-100">
      <div class="w-50">
        <h4>this.value</h4>
        <pre>
          {{ value }}
        </pre>
      </div>
      <div class="w-50">
        <h4>this.originalValue</h4>
        <pre>
          {{ originalValue }}
        </pre>
      </div>
    </div> -->
  </div>
</template>

<script>
  import { suppliosApi } from '@/js/api-service';
  import TagFieldsHeader from './TagFieldsHeader.vue';
  import TagFieldList from './TagFieldList.vue';

  export default {
    name: 'TagFields',
    components: { TagFieldsHeader, TagFieldList },
    props: {
      title: {
        type: String,
        default: 'Shared Tags',
      },
      value: { type: Object, required: false },
      // TODO - add a prop to limit the tagFields to a specific set, or to a specific LOCATION
      config: {
        type: Object,
        default: () => {
          return {
            modelLabel: null,  // something like 'items.Product'
            objectId: null,  // this is passed down to TagFieldList / TagFieldEditor
            layout: 'vertical',  // passed down to TagFieldList / TagFieldEditor - options are 'horizontal' or 'vertical' or 'dropdown' (select for single, multiselect for multiple)
            api: null,  // must have this if using internal edit (this component saves to backend directly) - must have method config.api.update_spl_taggings(objectId, createDataArray) that accepts an array of {object_id, tag_field_id, tag_ids} to update the taggings for this object
            useInternalEdit: false,
          };
        },
      },
      isEditing: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isLoading: false,
        tagFieldsLoaded: false,  // set true after fetching tagFields, so we have all the keys in the value object
        isEditingLocal: this.isEditing,
        tagFields: [],
        originalValue: { ...this.value },
        hasChanges: false,
      };
    },
    methods: {
      async getTagFields() {
        // fetch all the tagFields based on the modelLabel
        this.isLoading = true;
        const modelLabel = this.config.modelLabel;
        const { data: tagFields } = await suppliosApi.tags.tagField.list_for_model_label(modelLabel);
        // TODO - also have this return with all available tags (visible to TU) for each one?  would be nice.
        this.tagFields = tagFields;

        // Initialize the value object with all the tagFields ids if not present
        const localValue = { ...this.value };
        for (const tagField of this.tagFields) {
          //const slug = tagField.slug;
          const tfId = tagField.id;
          if (!localValue[tfId]) {
            this.$set(localValue, tfId, []);
          }
        }
        this.tagFieldsLoaded = true;
        console.log('done with getTagFields');
        this.$emit('input', localValue);
        // this.hasChanges = false;
      },
      handleTagFieldListInput(value) {
        // console.log('hello from handleTagFieldListInput', value);
        this.$emit('input', value);
      },
      onEdit() {
        this.isEditingLocal = true;
      },
      onEditCancel() {
        this.isEditingLocal = false;
        if (this.config.useInternalEdit) {
          const orig = { ...this.originalValue };
          console.log('orig', orig);
          this.$emit('input', orig);
        }
      },
      async onSave() {
        if (this.config.api) {
          await this.updateTaggings();
        }
        this.emitUpdate();
        this.isEditingLocal = false;
      },
      emitUpdate() {
        this.originalValue = { ...this.value };
        this.$emit('input', this.value);
      },
      async updateTaggings() {
        // console.log('hello from updateTaggings');
        // TODO - BLOCK THIS IF NOT EDITING LOCALLLY???? 
        const createDataArray = [];
        for (const tagField of this.tagFields) {
          //const slug = tagField.slug;
          const tfId = tagField.id;
          const tags = this.value[tfId] || [];
          const createData = {
            object_id: this.config.objectId,
            tag_field_id: tagField.id,
            tag_ids: tags.map((tag) => tag.id),
          };

          createDataArray.push(createData);
        }
        await this.config.api.update_spl_taggings(this.config.objectId, createDataArray);
        // TODO - what about return data?  should we update the value object with the new tags?  
        //     what if there are new tags on backend?  if we get out of sync, we could overwrite other writes
      },
    },
    // watch: {
    //   value: {
    //     handler(before, after) {
    //       console.log('hello from watch value - something changed!', before, after);
    //       this.hasChanges = true;
    //     },
    //     deep: true,
    //   },
    // },
    computed: {
      hasTagFields() {
        return Array.isArray(this.tagFields) && this.tagFields.length;
      },
      isEditingCurrent() {
        return this.isEditing || this.isEditingLocal;
      },
      // computedLocalValue() {
      //   const loc = this.value;
      //   console.log('hello from computedLocalValue', loc);
      //   return loc;
      // },
      // computedGroup() {
      //   const groupKey = 'more_commodities';
      //   const computedGroup = this.value[groupKey];
      //   console.log('hello from computedGroup', computedGroup);
      //   return computedGroup;
      // },
    },
    mounted() {
      this.getTagFields().finally(() => {
        this.isLoading = false;
      });
    },
  };
</script>
